import { useState, useEffect } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';
import DefaultCheckbox from '../../Forms/checkbox';
import DefaultInput from '../../Forms/input';

const Label = styled.label`
  font-size: 1rem;
  margin-right: 8px;
`;

const Input = styled(DefaultInput)`
  width: 250px;
  margin-right: 32px;
  padding: 0.5rem;
`;

const Checkbox = styled(DefaultCheckbox)`
  width: auto;
  margin-bottom: 0;
  margin-right: 16px;
  font-size: 1rem;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const Filters = styled.div`
  display: flex;
  flex-direction: row;
`;

function DataFilter({ onSearchChange, onTypeChange }) {
  const [searchValue, setSearchValue] = useState('');
  const [typeValues, setTypeValues] = useState({
    ai: true,
    profile: true,
    area: true,
  });

  const setDebouncedSearch = useDebouncedCallback(() => {
    onSearchChange(searchValue.trim());
  }, 500);

  const setDebouncedType = useDebouncedCallback(() => {
    onTypeChange(typeValues);
  }, 500);

  const handleSearchChange = (val) => {
    setSearchValue(val);
    setDebouncedSearch();
  };

  const handleTypeChange = (id, checked) => {
    setTypeValues(prev => ({
      ...prev, [id]: checked
    }));

    setDebouncedType();
  }

  useEffect(() => {
    onTypeChange(typeValues);
  }, []);

  return (
    <Wrapper>
      <Input
        id="search"
        placeholder="Search by Id or Name..."
        value={searchValue}
        onChange={(ev) => handleSearchChange(ev.target.value)} />

      <Label>Type:</Label>
      <Filters>
        <Checkbox
          id="ai"
          label="AI detection"
          checked={typeValues.ai}
          onChange={(e) => handleTypeChange('ai', e.target.checked)} />
        <Checkbox
          id="profile"
          label="Profile"
          checked={typeValues.profile}
          onChange={(e) => handleTypeChange('profile', e.target.checked)} />
        <Checkbox
          id="area"
          label="Area"
          checked={typeValues.area}
          onChange={(e) => handleTypeChange('area', e.target.checked)} />
      </Filters>
    </Wrapper>
  );
}


DataFilter.propTypes = {
  onSearchChange: func.isRequired,
  onTypeChange: func.isRequired,
}

export default DataFilter;